import React from 'react';
import { DatePicker, Typography } from 'antd';
import dayjs from 'dayjs';

const { MonthPicker } = DatePicker;
const { Title } = Typography;

interface MaturityHeaderProps {
  selectedMonth: number;
  selectedYear: number;
  onDateChange: (date: dayjs.Dayjs | null) => void;
}

const MaturityHeader: React.FC<MaturityHeaderProps> = ({
  selectedMonth,
  selectedYear,
  onDateChange,
}) => {
  return (
    <div className="flex justify-between items-center mb-6">
      <Title level={2} className="!mb-0 text-gray-800">
        Quản lý kỳ đáo hạn
      </Title>

      <div className="flex items-center space-x-4">
        <span className="text-gray-600 font-medium">Chọn tháng/năm:</span>
        <MonthPicker
          value={dayjs(`${selectedYear}-${selectedMonth}`)}
          format="MM/YYYY"
          placeholder="Chọn tháng và năm"
          className="w-48"
          onChange={onDateChange}
        />
      </div>
    </div>
  );
};

export default MaturityHeader;
